/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UploadDocument } from './UploadDocument';
import {
    UploadDocumentFromJSON,
    UploadDocumentFromJSONTyped,
    UploadDocumentToJSON,
} from './UploadDocument';

/**
 * 
 * @export
 * @interface UploadDocumentOutput
 */
export interface UploadDocumentOutput {
    /**
     * 
     * @type {UploadDocument}
     * @memberof UploadDocumentOutput
     */
    uploadDocument?: UploadDocument;
    /**
     * 
     * @type {Error}
     * @memberof UploadDocumentOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the UploadDocumentOutput interface.
 */
export function instanceOfUploadDocumentOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UploadDocumentOutputFromJSON(json: any): UploadDocumentOutput {
    return UploadDocumentOutputFromJSONTyped(json, false);
}

export function UploadDocumentOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadDocumentOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadDocument': !exists(json, 'uploadDocument') ? undefined : UploadDocumentFromJSON(json['uploadDocument']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function UploadDocumentOutputToJSON(value?: UploadDocumentOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uploadDocument': UploadDocumentToJSON(value.uploadDocument),
        'error': value.error,
    };
}

